module.exports = __webpack_public_path__ + "img/whatsapp_background.adbccee0.png";